export const StateIndicatorVariantTypes = { NEUTRAL: "neutral", INFO: "info", WARNING: "warning", SUCCESS: "success", ERROR: "error" } as const;
